import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkCls =
    "whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600";

  return (
    <header
      className={`sticky top-0 z-40 border-b transition-all ${
        scrolled
          ? "border-background-200/80 bg-background-50/95 backdrop-blur-md"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5" aria-label="吃瓜雷达 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-radar-fill text-lg" />
          </span>
          <span className="font-heading text-xl font-black leading-none tracking-tight text-foreground-950">
            吃瓜<span className="text-primary-600">雷达</span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <a key={l.id} href={`#${l.id}`} className={linkCls}>
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#join"
            className="inline-flex h-9 items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-300 bg-primary-50 px-4 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
          >
            <i className="ri-notification-2-line" />
            追更提醒
          </a>
          <a
            href="#join"
            className="inline-flex h-9 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-quill-pen-line" />
            投稿瓜点
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 lg:hidden" aria-label="移动端导航">
          <div className="mx-auto max-w-7xl space-y-1 px-4 py-4 md:px-6">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={() => setOpen(false)}
                className="block rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <div className="grid grid-cols-2 gap-3 pt-3">
              <a
                href="#join"
                onClick={() => setOpen(false)}
                className="inline-flex h-10 items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-4 text-sm font-semibold text-background-50"
              >
                投稿瓜点
              </a>
              <a
                href="#join"
                onClick={() => setOpen(false)}
                className="inline-flex h-10 items-center justify-center whitespace-nowrap rounded-full border border-primary-300 bg-primary-50 px-4 text-sm font-medium text-primary-700"
              >
                追更提醒
              </a>
            </div>
          </div>
        </nav>
      )}
    </header>
  );
}